import LandingPage from './pages/mainpage/LandingPage';
import { ThemeProvider } from './common/ThemeProvider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProjectPage from './pages/projectpage/ProjectPage';

const App = ()  => {

  const routes = [
    {
        path: '/',
        element: <LandingPage />
    },
    {
        path: '/project/:id',
        element: <ProjectPage />
    }
  ]

  return (
    <BrowserRouter >
      <div className='scrollbar-hidden cursor-fancy_w active:cursor-fancyactive_b'>
        <ThemeProvider>
              <>
                <div className='w-full flex flex-col justify-center font-martian'>
                  <Routes>
                    {
                      routes.map((route, index) => {
                        return <Route path={route.path} element={route.element} key={index}/>
                      })
                    }
                  </Routes>
                </div>
              </>
        </ThemeProvider>
      </div>
    </BrowserRouter>
  )
}

export default App;
